import { Link } from "react-router-dom";

export default function HowItWorks() {
  return (
    <section className="tw-py-10 tw-text-black tw-relative tw-bg-[#EDEDED] tw-overflow-hidden">
      {/* Phone Image - desktop absolute, mobile inline */}
      <img
        src="/nestroot/HowItWorks.png"
        alt="Claims Process on Phone"
        className="tw-hidden md:tw-block tw-absolute md:tw-h-[60%] md:tw-top-auto md:tw-bottom-0 md:tw-right-0 md:tw-w-1/2 lg:tw-h-[90%] lg:tw-top-10 lg:tw-right-20 lg:tw-w-8/12 tw-object-contain tw-opacity-90"
      />

      <div className="tw-w-[90%] md:tw-w-4/5 tw-mx-auto tw-relative tw-z-10 tw-flex tw-flex-col tw-min-h-[600px]">
        {/* Top Centered Title */}
        <h1 
          className="tw-text-4xl tw-text-center tw-mb-10 tw-font-bold"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          How it works
        </h1>

        {/* Content */}
        <div className="tw-flex-1 tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-gap-8">
          <div className="tw-w-full md:tw-w-1/2 tw-flex tw-flex-col tw-items-start tw-text-left">
            <h2 
              className="tw-text-4xl md:tw-text-5xl tw-font-medium tw-mb-6 tw-leading-tight"
              style={{ fontFamily: "'Instrument Serif', serif" }}
            >
              Easy claims, great service
            </h2>

            <p 
              className="tw-text-xl md:tw-text-2xl tw-opacity-90 tw-mb-10 tw-leading-relaxed tw-max-w-lg"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Filing a claim is simple. They&apos;ll process your claim in minutes 
              and once approved, they&apos;ll mail you details on your replacement.
            </p>

            <Link
              to="/customer-login"
              className="tw-text-black tw-border tw-border-black tw-px-8 tw-py-4 tw-rounded-full tw-text-xl tw-font-bold tw-transition-all tw-duration-500 hover:tw-bg-black hover:tw-text-white tw-shadow-lg"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Start a Claim
            </Link>
          </div>

          {/* Phone image visible on mobile, inline */}
          <div className="tw-hidden">
            <img
              src="/nestroot/HowItWorks.png"
              alt="Claims Process on Phone"
              className="tw-w-4/5 tw-object-contain tw-opacity-90"
            />
          </div>
        </div>
      </div>

    </section>
  );
}
